module.exports = __webpack_public_path__ + "img/mahoutcamp64_ua.877c70f9.webp";